import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUsersListApi } from "../../end-points/userList"

const initialState = {
  loading: false,
  error: null,
  success: false,
};

export const getUsersList = createAsyncThunk(
  "userList/getUsersList", getUsersListApi
);

const usersListSlice = createSlice({
  name: "userList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUsersList.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getUsersList.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.loading = false;
    })
    builder.addCase(getUsersList.rejected, (state, action) => {
      console.log("Error", state, action);
      state.loading = false;
    })
  }
});

export default usersListSlice.reducer;